import { useEffect, useState } from 'react';

const MESSAGES = [
  'Envoi de votre dossier en cours…',
  'Vérification de vos informations…',
  'Analyse de votre profil emprunteur…',
  'Création de votre espace personnel…',
  'Finalisation de votre demande…',
];

export function SubmitLoadingOverlay() {
  const [messageIndex, setMessageIndex] = useState(0);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Fade in
    const fadeIn = requestAnimationFrame(() => setVisible(true));

    const interval = setInterval(() => {
      setMessageIndex(prev => (prev + 1) % MESSAGES.length);
    }, 2400);

    return () => {
      cancelAnimationFrame(fadeIn);
      clearInterval(interval);
    };
  }, []);

  return (
    <div
      style={{
        opacity: visible ? 1 : 0,
        transition: 'opacity 0.4s ease-out',
      }}
      className="fixed inset-0 z-50 bg-white flex flex-col items-center justify-center px-6"
    >
      {/* Animated bar */}
      <div className="w-48 h-0.5 bg-neutral-100 rounded-full overflow-hidden mb-10">
        <div className="h-full bg-primary-600 rounded-full submit-bar-animation" />
      </div>

      {/* Message */}
      <p
        key={messageIndex}
        className="text-neutral-600 text-sm text-center tracking-wide submit-message-animation"
        style={{ minHeight: '1.5rem' }}
      >
        {MESSAGES[messageIndex]}
      </p>

      {/* Dots */}
      <div className="flex gap-1.5 mt-6">
        {[0, 1, 2].map(i => (
          <span
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-primary-400"
            style={{
              animation: `submit-dot-pulse 1.4s ease-in-out infinite`,
              animationDelay: `${i * 0.2}s`,
            }}
          />
        ))}
      </div>
    </div>
  );
}
